import { observer } from 'mobx-react-lite';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import ProfileModel from 'src/models/account/ProfileModel';
interface IValidate {
  model: ProfileModel;
}
const Recaptcha = ({ model }: IValidate) => {
  function onChange(value) {
      model.notARobot = !model.notARobot
  }
  return <ReCAPTCHA sitekey='6LeIb8cbAAAAAK5u7ViCCvBMnXly1EG1bpeMp2D-' onChange={onChange} />;
};

export default observer(Recaptcha);